<template>
   <ul class="expense-list">
      <expense-list-entry
        v-for="expense in expenses"
        :key="expense.id"
        :expense="expense"
        @deleted-expense="(expenseId) => $emit('deleted-expense', expenseId)"
      />
    </ul>
</template>

<script>
  import ExpenseListEntry from 'components/Expenses/ExpenseListEntry.vue'

  export default {
    components: {
      ExpenseListEntry
    },
    props: {
      expenses: {
        required: true,
        validator: (prop) => Array.isArray(prop) || prop === null
      }
    }
  }
</script>

<style lang="stylus">
  @import '~variables'

  .expense-list
    margin 0
    padding 0
    width 100%
    border-radius 4px
    background white
    overflow hidden
    border: 1px solid $border-color
</style>
